module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products/single-product/nutrition/product-nutrition.component.css
// module id = ./src/app/products/single-product/nutrition/product-nutrition.component.css
// module chunks = main